<template>
    <div>
        <c-search-box ref="searchbox" :isShowSearch="false" @enter="getList">
            <template slot="search">
                <div class="col-6">
                    <!-- 사업장 -->
                    <c-plant
                        type="search"
                        name="plantCd"
                        v-model="searchParam.plantCd"
                        @input="getList"
                    />
                </div>
                <div class="col-6">
                    <c-dept
                        type="search"
                        name="deptCd"
                        label="관리부서"
                        v-model="searchParam.deptCd"
                        @input="getList"
                    />
                </div>
            </template>
        </c-search-box>
        <c-table
            ref="table"
            title="장소 목록"
            parentProperty="upMdmLocationId"
            customID="mdmLocationId"
            :columns="gridColumns"
            :data="grid.data"
            :gridHeight="grid.height"
            :filtering="true"
            :columnSetting="false"
            :isFullScreen="false"
            :selection="popupParam.type"
            rowKey="mdmLocationId"
            @rowDblclick="rowDblclick"
        >
        </c-table>
        <div class="space-bottom-button"></div>
        <!-- 버튼 영역 -->
        <div class="search-box-btn">
            <q-btn-group outline>
                <c-btn
                    label="선택"
                    icon="check"
                    color="teal-5"
                    @btnClicked="select"
                />
            </q-btn-group>
        </div>
    </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
    name: "locationPop",
    props: {
        popupParam: {
            type: Object,
            default: function () {
                return {
                    type: "single",
                    plantCd: "",
                    isMapShowing: false,
                    etcFlag: "N",
                };
            },
        },
        contentHeight: {
            type: [String, Number],
            default: function () {
                return "auto";
            },
        },
    },
    data() {
        return {
            searchParam: {
                plantCd: null,
                useFlag: "Y",
                etcFlag: "N",
                deptCd: null,
            },
            grid: {
                data: [],
                height: "300px",
            },
            editable: true,
            listUrl: "",
        };
    },
    beforeCreate() {},
    created() {},
    beforeMount() {
        Object.assign(this.$data, this.$options.data());
    },
    mounted() {
        this.init();
    },
    beforeDestroy() {},
    computed: {
        inputEditable() {
            return this.isModify && this.editable;
        },
        gridColumns() {
            let cols = [];
            if (this.popupParam.isMapShowing) {
                cols = [
                    {
                        name: "deptName",
                        field: "deptName",
                        label: "관리부서",
                        align: "center",
                        sortable: false,
                        style: "width: 140px",
                    },
                    {
                        name: "locationName",
                        field: "locationName",
                        label: "장소명",
                        align: "left",
                        sortable: true,
                    },
                    {
                        name: "mapName",
                        field: "mapName",
                        label: "배치도면명",
                        align: "left",
                        sortable: true,
                    },
                ];
            } else {
                cols = [
                    {
                        name: "deptName",
                        field: "deptName",
                        label: "관리부서",
                        align: "center",
                        sortable: false,
                        style: "width: 140px",
                    },
                    {
                        name: "locationName",
                        field: "locationName",
                        label: "장소명",
                        align: "left",
                        sortable: true,
                    },
                ];
            }
            return cols;
        },
    },
    methods: {
        init() {
            // role setting
            this.editable = this.$route.meta.editable;
            // url setting
            this.listUrl = selectConfig.mdm.location.list.url;
            // code setting
            if (this.popupParam.plantCd) {
                this.searchParam.plantCd = this.popupParam.plantCd;
            }
            if (this.popupParam.etcFlag) {
                this.searchParam.etcFlag = this.popupParam.etcFlag;
            }
            // list setting
            this.getList();
        },
        getList() {
            this.$http.url = this.listUrl;
            this.$http.type = "GET";
            this.$http.param = this.searchParam;
            this.$http.request((_result) => {
                this.grid.data = _result.data;
            });
        },
        select() {
            let selectData = this.$refs["table"].selected;
            if (!selectData || selectData.length === 0) {
                window.getApp.$emit("ALERT", {
                    title: "안내", // 안내
                    message: "선택된 항목이 없습니다.", // 선택된 항목이 없습니다.
                    type: "warning", // success / info / warning / error
                });
            } else {
                this.$emit("closePopup", selectData);
            }
        },
        rowDblclick(row) {
            if (this.popupParam.type === "single") {
                this.$emit("closePopup", [row]);
            }
        },
    },
};
</script>
